module.exports = __webpack_public_path__ + "media/images/logo-white-42c11bb1875ba3dd05966f77b0be1ba3.png";